<template>
  <vv-screen-wrapper :style="screenStyle">
    <div class="screen-container">
      <!-- Rating speech bubble -->
      <div class="rating-wrapper">
        <vv-star-notation
          :title="$t('tasting.rating.rating_title')"
          :question="$t('tasting.rating.rating_text', { bottle: tasting.bottleName })"
          v-model="rating"
        />
      </div>

      <!-- Thanks user text -->
      <transition name="fade">
        <vv-box v-if="rating > 0" :title="$t('tasting.rating.thanks_title')" id="rating-text">{{
          text
        }}</vv-box>
      </transition>

      <div
        class="button-wrapper"
        v-if="remoteConfig.getBoolean('tasting_ask_create_account') && !isUserLogged"
      >
        <vv-button @click="createAccount">{{ $t('tasting.rating.create_account') }}</vv-button>
      </div>

      <div class="cta">
        <vv-button v-if="!isFromTaste" @click="go">{{ $t('tasting.rating.button') }}</vv-button>
        <vv-button v-else @click="returnToTaste">{{ $t('tasting.rating.other_one') }}</vv-button>
      </div>
    </div>
  </vv-screen-wrapper>
</template>

<script>
import { mapGetters } from 'vuex'
import get from 'lodash/get'

import { VvBox, VvButton, VvStarNotation, VvScreenWrapper } from '@/components/common'
import remoteConfigMixin from '@/mixins/remoteConfig'
import userMixin from '@/mixins/user'
import { REGISTER_COMPLETION } from '@/store/modules/completion/types'
import { tasting_save_feedback, tasting_redirect_tasting_list } from '@/lib/remote-config/constants'

export default {
  name: 'TastingRating',
  mixins: [remoteConfigMixin, userMixin],
  components: { VvBox, VvButton, VvStarNotation, VvScreenWrapper },
  data() {
    return { 
      rating: 0,
      prevRoute: null
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },
  mounted() {
    var statuscomplete = true
    const tmp = get(this.$store, ['state', 'completion', 'tasting', this.tasting.id], null)
    this.rating = tmp && tmp['rating'] ? parseInt(tmp['rating']) : 0
    if (this.comingFromListTasting) {
      if (!tmp) {
        statuscomplete = false
      } else if (tmp && tmp['complete'] == false) {
        statuscomplete = false
      }
    }
    this.$store.dispatch(REGISTER_COMPLETION, {
      contentType: 'tasting',
      id: this.tasting.id,
      status: { complete: statuscomplete }
    })
  },
  computed: {
    ...mapGetters({ tasting: 'currentTasting', firebaseId: 'tastingFirebaseId' }),
    screenStyle() {
      return `background: url(${this.tasting.ratingBackgroundImage}); background-size: cover;`
    },
    text() {
      return this.$t('tasting.rating.thanks_text_' + this.rating)
    },
    comingFromListTasting() {
      return this.prevRoute && this.prevRoute.path === '/listTasting' ? true : false
    },
    isFromTaste() {
      return localStorage.getItem('comingFromTasteThemeId') ? true : false
    },
  },
  methods: {
    go() {
      this.saveRating()
      if (this.remoteConfig.getBoolean(tasting_redirect_tasting_list)) {
        this.$router.push({ name: 'listTasting' })
      } else {
        this.$router.push({ name: 'themeList' })
      }
    },
    returnToTaste() {
      this.saveRating()

      let idTheme = localStorage.getItem('comingFromTasteThemeId')
      localStorage.removeItem('comingFromTasteThemeId')

      this.$router.push({ name: 'theme', params: {themeId: idTheme} })
    },
    createAccount() {
      this.$router.push({ name: 'register' })
    },
    saveRating() {
      var statuscomplete = true
      if (this.comingFromListTasting) {
        const tmp = get(this.$store, ['state', 'completion', 'tasting', this.tasting.id], null)
        if (!tmp) {
          statuscomplete = false
        } else if (tmp && tmp['complete'] == false) {
          statuscomplete = false
        }
      }
      if (this.remoteConfig.getBoolean(tasting_save_feedback) && this.rating > 0) {
        this.$store.dispatch(REGISTER_COMPLETION, {
          contentType: 'tasting',
          id: this.tasting.id,
          status: {
            complete: statuscomplete,
            rating: this.rating
          }
        })
      }
    }
  },
  watch: {
    rating() {
      this.saveRating()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.button-wrapper {
  text-align: center;
}

#rating-text {
  color: $primary !important;
}

.body {
  padding: 20px 30px;
  text-align: left;
}

.rating-wrapper {
  margin-bottom: 30px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
